// Textos de esta área: { es: {...}, en: {...}, pt: {...} }
// Pantallas: registro, olvido de contraseña, activación, bienvenido, login pendiente, cerrar sesión.
export default {
  es: {
    'registro.nombreApellido': 'Escribe tu nombre y apellido.',
    'registro.claveCorta': 'La contraseña debe tener al menos 6 caracteres.',
    'registro.clavesNoCoinciden': 'Las contraseñas no coinciden.',
    'registro.aceptaTerminos': 'Debes aceptar los términos y condiciones.',
    'registro.cuentaCreada': 'Cuenta creada',
    'registro.cuentaCreadaTxt1': 'Te enviamos un enlace de confirmación a ',
    'registro.cuentaCreadaTxt2': '. Ábrelo para activar tu cuenta y luego inicia sesión. Si no lo ves, revisa la carpeta de spam.',
    'registro.irLogin': 'Ir a iniciar sesión',
    'registro.titulo': 'Crea tu cuenta',
    'registro.subtitulo': 'Tarda un minuto. Luego verificaremos tu identidad para que puedas invertir.',
    'registro.nombre': 'Nombre y apellido',
    'registro.correo': 'Correo electrónico',
    'registro.correoEjemplo': 'tu@email.com',
    'registro.clave': 'Contraseña',
    'registro.ocultar': 'Ocultar',
    'registro.mostrar': 'Mostrar',
    'registro.claveAyuda': 'Mínimo 6 caracteres.',
    'registro.repite': 'Repite la contraseña',
    'registro.origenPregunta': '¿Dónde escuchaste de Panther7?',
    'registro.origenElige': 'Selecciona una opción',
    'registro.origen0': 'Instagram',
    'registro.origen1': 'Facebook',
    'registro.origen2': 'Email',
    'registro.origen3': 'Youtube',
    'registro.origen4': 'Google',
    'registro.origen5': 'Recomendación',
    'registro.origen6': 'Publicidad en Radio/TV',
    'registro.origen7': 'Un Amigo/a',
    'registro.tengoCodigo': 'Tengo un código de referido',
    'registro.codigo': 'Código de referido',
    'registro.acepto': 'Acepto los ',
    'registro.terminosLink': 'términos y condiciones',
    'registro.creando': 'Creando tu cuenta…',
    'registro.crear': 'Crear mi cuenta',
    'registro.yaTienes': '¿Ya tienes cuenta?',
    'registro.iniciar': 'Iniciar sesión',
    'registro.nota': 'Tu registro pasa por una validación de datos y documentos.',
    'registro.cerrar': 'Cerrar',
    'registro.tycTitulo': 'TÉRMINOS Y CONDICIONES GENERALES DE USO DE LA PLATAFORMA WEB "PANTHER7"',
    'registro.tycIntro': 'Los presentes Términos y Condiciones Generales de uso establecerán los términos y condiciones aplicables al uso de los contenidos, productos y servicios ofrecidos a través de la plataforma web PANTHER7...',
    'registro.tycGeneralesT': 'Condiciones Generales',
    'registro.tycGenerales': 'PANTHER7 es un producto de ESSENTIAL FINANCIAL INVESTMENT CORP, una corporación registrada en los Estados Unidos de América...',
    'registro.tycDatosT': 'Política de Tratamiento de Datos',
    'registro.tycDatos': 'Con la aceptación de esta autorización, manifiesto que he sido informado por Panther7...',
    'registro.tycRegistroT': 'Registro de Usuario',
    'registro.tycRegistro': 'Para registrarse en el Sitio, el usuario primero debe leer y aceptar los "Términos de uso y la Política de privacidad"...',
    'registro.aceptarBtn': 'Aceptar términos',
    'olvido.revisa': 'Revisa tu correo',
    'olvido.revisaTxt1': 'Si ',
    'olvido.revisaTxt2': ' está registrado, te enviamos un enlace para crear una nueva contraseña. Si no llega en unos minutos, mira en spam.',
    'olvido.volver': 'Volver a iniciar sesión',
    'olvido.titulo': 'Recupera tu contraseña',
    'olvido.subtitulo': 'Escribe tu correo y te enviamos un enlace para crear una nueva.',
    'olvido.correo': 'Correo electrónico',
    'olvido.correoEjemplo': 'tu@email.com',
    'olvido.enviando': 'Enviando…',
    'olvido.enviar': 'Enviarme el enlace',
    'olvido.sinCuenta': '¿No tienes cuenta?',
    'olvido.registrate': 'Regístrate',
    'activar.errorEnlace': 'No pudimos validar el enlace.',
    'activar.validando': 'Validando tu correo',
    'activar.momento': 'Un momento, por favor.',
    'activar.confirmado': '¡Correo confirmado!',
    'activar.activa': 'Tu cuenta está activa. Ya puedes iniciar sesión.',
    'activar.noValido': 'No pudimos validar tu correo',
    'activar.noValidoTxt': 'El enlace pudo haber vencido o ya fue usado. Inicia sesión: si falta confirmar, podrás pedir uno nuevo.',
    'activar.iniciar': 'Iniciar sesión',
    'bienvenido.saludo': 'Bienvenido',
    'bienvenido.alSimulador': ' al simulador',
    'bienvenido.ultima': 'Su Última Conexión fué {fecha}',
    'pendiente.email': 'Email',
    'pendiente.emailPh': 'Tu Email',
    'pendiente.password': 'Password',
    'pendiente.passwordPh': 'Tu Password',
    'pendiente.titulo': 'Iniciar Sesion',
    'pendiente.crear': 'Crear tu cuenta Ahora!',
    'cerrar.salir': 'Cerrar sesión',
    'srv:Usuario creado con éxito. Confirme haciendo clic en el enlace que se le envió en su correo electrónico.': 'Usuario creado con éxito. Confirme haciendo clic en el enlace que se le envió en su correo electrónico.',
    'srv:No es posible crear al usuario': 'No es posible crear al usuario',
    'srv:Verifique su correo electrónico y siga las instrucciones para recuperar su clave.': 'Verifique su correo electrónico y siga las instrucciones para recuperar su clave.',
    'srv:Email no encontrado.': 'Email no encontrado.',
    'srv:Token inválido': 'Token inválido',
    'srv:Email verificado': 'Email verificado',
    'srv:Usuario no existe': 'Usuario no existe',
    'srv:Usuario ya verificado': 'Usuario ya verificado',
    'srv:Datos inválidos': 'Datos inválidos',
  },
  en: {
    'registro.nombreApellido': 'Enter your first and last name.',
    'registro.claveCorta': 'Your password must be at least 6 characters long.',
    'registro.clavesNoCoinciden': 'The passwords do not match.',
    'registro.aceptaTerminos': 'You must accept the terms and conditions.',
    'registro.cuentaCreada': 'Account created',
    'registro.cuentaCreadaTxt1': 'We sent a confirmation link to ',
    'registro.cuentaCreadaTxt2': '. Open it to activate your account, then log in. If you don\'t see it, check your spam folder.',
    'registro.irLogin': 'Go to log in',
    'registro.titulo': 'Create your account',
    'registro.subtitulo': 'It takes a minute. Then we will verify your identity so you can invest.',
    'registro.nombre': 'First and last name',
    'registro.correo': 'Email address',
    'registro.correoEjemplo': 'you@email.com',
    'registro.clave': 'Password',
    'registro.ocultar': 'Hide',
    'registro.mostrar': 'Show',
    'registro.claveAyuda': 'Minimum 6 characters.',
    'registro.repite': 'Repeat your password',
    'registro.origenPregunta': 'Where did you hear about Panther7?',
    'registro.origenElige': 'Select an option',
    'registro.origen0': 'Instagram',
    'registro.origen1': 'Facebook',
    'registro.origen2': 'Email',
    'registro.origen3': 'Youtube',
    'registro.origen4': 'Google',
    'registro.origen5': 'Recommendation',
    'registro.origen6': 'Radio/TV advertising',
    'registro.origen7': 'A friend',
    'registro.tengoCodigo': 'I have a referral code',
    'registro.codigo': 'Referral code',
    'registro.acepto': 'I accept the ',
    'registro.terminosLink': 'terms and conditions',
    'registro.creando': 'Creating your account…',
    'registro.crear': 'Create my account',
    'registro.yaTienes': 'Already have an account?',
    'registro.iniciar': 'Log in',
    'registro.nota': 'Your registration goes through a data and document validation.',
    'registro.cerrar': 'Close',
    'registro.tycTitulo': 'GENERAL TERMS AND CONDITIONS OF USE OF THE "PANTHER7" WEB PLATFORM',
    'registro.tycIntro': 'These General Terms and Conditions of Use set out the terms and conditions applicable to the use of the content, products and services offered through the PANTHER7 web platform...',
    'registro.tycGeneralesT': 'General Conditions',
    'registro.tycGenerales': 'PANTHER7 is a product of ESSENTIAL FINANCIAL INVESTMENT CORP, a corporation registered in the United States of America...',
    'registro.tycDatosT': 'Data Processing Policy',
    'registro.tycDatos': 'By accepting this authorization, I state that I have been informed by Panther7...',
    'registro.tycRegistroT': 'User Registration',
    'registro.tycRegistro': 'To register on the Site, the user must first read and accept the "Terms of Use and Privacy Policy"...',
    'registro.aceptarBtn': 'Accept terms',
    'olvido.revisa': 'Check your email',
    'olvido.revisaTxt1': 'If ',
    'olvido.revisaTxt2': ' is registered, we sent you a link to create a new password. If it doesn\'t arrive in a few minutes, check your spam folder.',
    'olvido.volver': 'Back to log in',
    'olvido.titulo': 'Recover your password',
    'olvido.subtitulo': 'Enter your email and we will send you a link to create a new one.',
    'olvido.correo': 'Email address',
    'olvido.correoEjemplo': 'you@email.com',
    'olvido.enviando': 'Sending…',
    'olvido.enviar': 'Send me the link',
    'olvido.sinCuenta': 'Don\'t have an account?',
    'olvido.registrate': 'Sign up',
    'activar.errorEnlace': 'We could not validate the link.',
    'activar.validando': 'Validating your email',
    'activar.momento': 'One moment, please.',
    'activar.confirmado': 'Email confirmed!',
    'activar.activa': 'Your account is active. You can now log in.',
    'activar.noValido': 'We could not validate your email',
    'activar.noValidoTxt': 'The link may have expired or has already been used. Log in: if confirmation is still pending, you can request a new one.',
    'activar.iniciar': 'Log in',
    'bienvenido.saludo': 'Welcome',
    'bienvenido.alSimulador': ' to the simulator',
    'bienvenido.ultima': 'Your last connection was {fecha}',
    'pendiente.email': 'Email',
    'pendiente.emailPh': 'Your Email',
    'pendiente.password': 'Password',
    'pendiente.passwordPh': 'Your Password',
    'pendiente.titulo': 'Log In',
    'pendiente.crear': 'Create your account now!',
    'cerrar.salir': 'Log out',
    'srv:Usuario creado con éxito. Confirme haciendo clic en el enlace que se le envió en su correo electrónico.': 'User created successfully. Please confirm by clicking the link sent to your email.',
    'srv:No es posible crear al usuario': 'Unable to create the user',
    'srv:Verifique su correo electrónico y siga las instrucciones para recuperar su clave.': 'Check your email and follow the instructions to recover your password.',
    'srv:Email no encontrado.': 'Email not found.',
    'srv:Token inválido': 'Invalid token',
    'srv:Email verificado': 'Email verified',
    'srv:Usuario no existe': 'User does not exist',
    'srv:Usuario ya verificado': 'User already verified',
    'srv:Datos inválidos': 'Invalid data',
  },
  pt: {
    'registro.nombreApellido': 'Escreva seu nome e sobrenome.',
    'registro.claveCorta': 'A senha deve ter pelo menos 6 caracteres.',
    'registro.clavesNoCoinciden': 'As senhas não coincidem.',
    'registro.aceptaTerminos': 'Você deve aceitar os termos e condições.',
    'registro.cuentaCreada': 'Conta criada',
    'registro.cuentaCreadaTxt1': 'Enviamos um link de confirmação para ',
    'registro.cuentaCreadaTxt2': '. Abra-o para ativar sua conta e depois faça login. Se não o encontrar, verifique a pasta de spam.',
    'registro.irLogin': 'Ir para o login',
    'registro.titulo': 'Crie sua conta',
    'registro.subtitulo': 'Leva um minuto. Depois verificaremos sua identidade para que você possa investir.',
    'registro.nombre': 'Nome e sobrenome',
    'registro.correo': 'E-mail',
    'registro.correoEjemplo': 'voce@email.com',
    'registro.clave': 'Senha',
    'registro.ocultar': 'Ocultar',
    'registro.mostrar': 'Mostrar',
    'registro.claveAyuda': 'Mínimo de 6 caracteres.',
    'registro.repite': 'Repita a senha',
    'registro.origenPregunta': 'Onde você ouviu falar da Panther7?',
    'registro.origenElige': 'Selecione uma opção',
    'registro.origen0': 'Instagram',
    'registro.origen1': 'Facebook',
    'registro.origen2': 'E-mail',
    'registro.origen3': 'Youtube',
    'registro.origen4': 'Google',
    'registro.origen5': 'Recomendação',
    'registro.origen6': 'Publicidade no rádio/TV',
    'registro.origen7': 'Um amigo(a)',
    'registro.tengoCodigo': 'Tenho um código de indicação',
    'registro.codigo': 'Código de indicação',
    'registro.acepto': 'Aceito os ',
    'registro.terminosLink': 'termos e condições',
    'registro.creando': 'Criando sua conta…',
    'registro.crear': 'Criar minha conta',
    'registro.yaTienes': 'Já tem uma conta?',
    'registro.iniciar': 'Entrar',
    'registro.nota': 'Seu cadastro passa por uma validação de dados e documentos.',
    'registro.cerrar': 'Fechar',
    'registro.tycTitulo': 'TERMOS E CONDIÇÕES GERAIS DE USO DA PLATAFORMA WEB "PANTHER7"',
    'registro.tycIntro': 'Estes Termos e Condições Gerais de Uso estabelecem os termos e condições aplicáveis ao uso dos conteúdos, produtos e serviços oferecidos por meio da plataforma web PANTHER7...',
    'registro.tycGeneralesT': 'Condições Gerais',
    'registro.tycGenerales': 'A PANTHER7 é um produto da ESSENTIAL FINANCIAL INVESTMENT CORP, uma corporação registrada nos Estados Unidos da América...',
    'registro.tycDatosT': 'Política de Tratamento de Dados',
    'registro.tycDatos': 'Ao aceitar esta autorização, declaro que fui informado pela Panther7...',
    'registro.tycRegistroT': 'Cadastro de Usuário',
    'registro.tycRegistro': 'Para se cadastrar no Site, o usuário deve primeiro ler e aceitar os "Termos de Uso e a Política de Privacidade"...',
    'registro.aceptarBtn': 'Aceitar termos',
    'olvido.revisa': 'Verifique seu e-mail',
    'olvido.revisaTxt1': 'Se ',
    'olvido.revisaTxt2': ' estiver cadastrado, enviamos um link para criar uma nova senha. Se não chegar em alguns minutos, verifique o spam.',
    'olvido.volver': 'Voltar ao login',
    'olvido.titulo': 'Recupere sua senha',
    'olvido.subtitulo': 'Digite seu e-mail e enviaremos um link para criar uma nova.',
    'olvido.correo': 'E-mail',
    'olvido.correoEjemplo': 'voce@email.com',
    'olvido.enviando': 'Enviando…',
    'olvido.enviar': 'Enviar o link para mim',
    'olvido.sinCuenta': 'Não tem uma conta?',
    'olvido.registrate': 'Cadastre-se',
    'activar.errorEnlace': 'Não foi possível validar o link.',
    'activar.validando': 'Validando seu e-mail',
    'activar.momento': 'Um momento, por favor.',
    'activar.confirmado': 'E-mail confirmado!',
    'activar.activa': 'Sua conta está ativa. Você já pode entrar.',
    'activar.noValido': 'Não foi possível validar seu e-mail',
    'activar.noValidoTxt': 'O link pode ter expirado ou já foi usado. Entre na sua conta: se ainda faltar a confirmação, você poderá pedir um novo.',
    'activar.iniciar': 'Entrar',
    'bienvenido.saludo': 'Bem-vindo',
    'bienvenido.alSimulador': ' ao simulador',
    'bienvenido.ultima': 'Sua última conexão foi {fecha}',
    'pendiente.email': 'E-mail',
    'pendiente.emailPh': 'Seu E-mail',
    'pendiente.password': 'Senha',
    'pendiente.passwordPh': 'Sua Senha',
    'pendiente.titulo': 'Entrar',
    'pendiente.crear': 'Crie sua conta agora!',
    'cerrar.salir': 'Sair',
    'srv:Usuario creado con éxito. Confirme haciendo clic en el enlace que se le envió en su correo electrónico.': 'Usuário criado com sucesso. Confirme clicando no link enviado ao seu e-mail.',
    'srv:No es posible crear al usuario': 'Não é possível criar o usuário',
    'srv:Verifique su correo electrónico y siga las instrucciones para recuperar su clave.': 'Verifique seu e-mail e siga as instruções para recuperar sua senha.',
    'srv:Email no encontrado.': 'E-mail não encontrado.',
    'srv:Token inválido': 'Token inválido',
    'srv:Email verificado': 'E-mail verificado',
    'srv:Usuario no existe': 'Usuário não existe',
    'srv:Usuario ya verificado': 'Usuário já verificado',
    'srv:Datos inválidos': 'Dados inválidos',
  },
};
